import { useState, useEffect, useRef } from 'preact/hooks';
import axios from 'axios';
import Podcast from '~/shared/components/Podcast';
import createObserver from '~/utils/adobserver';

function LoadingPodcast() {
  return (
    <div className="flex py-4 border-b border-gray ">
      <div className="flex-grow flex-shrink-0 w-24 h-24 mr-4 bg-gray-400 rounded md:w-32 md:h-32" />
      <div className="flex flex-col items-start justify-center w-full">
        <div className="w-5/12 h-3 mb-1 bg-gray-400" />
        <div className="w-4/12 h-3 bg-gray-400" />
      </div>
    </div>
  );
}
function getUrlWithTracking({ link: url, slot, id: pid }) {
  const urlParams = new URLSearchParams({
    pid,
    s: slot,
  });
  return `${url}?${urlParams.toString()}`;
}

export function Ad({ slot }) {
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(false);
  const [ad, setAd] = useState(false);
  const adRef = useRef(null);

  function fetchAd() {
    axios
      .get(`/api/ad?s=${slot}`)
      .then(({ data }) => {
        setFetching(false);
        setAd(data.data);
        setError(false);
      })
      .catch(() => {
        setError(true);
      });
  }

  useEffect(() => {
    fetchAd();
  }, []);

  useEffect(() => {
    if (!ad) return;
    const adTarget = { el: adRef.current, pid: ad.id, slot };
    if (adRef.current !== null) {
      const unobserve = createObserver(adTarget, {
        hooks: {
          onReplace() {
            fetchAd();
          },
        },
      });
      return () => unobserve();
    }
    return () => null;
  }, [ad]);

  const noAdsAvailable = !fetching && !ad;
  if (error || noAdsAvailable) {
    return null;
  }
  const comp = fetching ? (
    <LoadingPodcast />
  ) : (
    <Podcast
      adNode={adRef}
      pid={ad.id}
      key={ad.id}
      title={ad.title}
      genre={ad.categoryName}
      url={getUrlWithTracking({ ...ad, slot })}
      imageSrc={ad.images.medium}
      imageSrcset={ad.images.srcset}
      extraText={ad.meta && ad.meta.title}
    />
  );
  return comp;
}
